/* RAVIN Paper Rivals v4: start minimized on every page; animated compact reveal. */
(function(){
  function setup(root){
    if(root.dataset.rvReady==='4')return;
    root.dataset.rvReady='4';
    var minimize=root.querySelector('[data-rv-minimize]');
    var restore=root.querySelector('[data-rv-restore]');
    var dock=root.querySelector('.rv-rivals__dock');
    var quip=root.querySelector('[data-rv-quip]');
    var ar=document.documentElement.lang.toLowerCase().indexOf('ar')===0;
    var phrases=ar?['من غير خناق يا جماعة','فيه إيه يا جدعان؟','الاتنين بيبصوا لبعض','يا ساتر...']:['NO FIGHTING, PLEASE','WHO INVITED WHO?','THEY HAVE BEEF.','AWKWARD...'];
    var actions=['is-rivalry','is-judging','is-surprised'];
    var step=0,idleTimer=0,introTimer=0,endTimer=0;
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var still=root.classList.contains('rv-rivals--still');
    function reset(){actions.forEach(function(c){root.classList.remove(c)});}
    function play(){
      if(still||reduced||root.classList.contains('is-minimized')||document.hidden||!root.isConnected)return;
      if(dock&&(dock.matches(':hover')||dock.contains(document.activeElement)))return;
      reset();
      var i=step++%actions.length;
      root.classList.add(actions[i]);
      if(root.dataset.rvJokes==='true'&&quip)quip.textContent=phrases[(i+1)%phrases.length];
      clearTimeout(endTimer);
      endTimer=setTimeout(reset,1100);
    }
    function setMinimized(value,moveFocus){
      clearTimeout(introTimer);
      clearTimeout(endTimer);
      reset();
      root.classList.remove('is-opening');
      root.classList.toggle('is-minimized',value);
      root.hidden=false;
      if(restore)restore.setAttribute('aria-expanded',value?'false':'true');
      if(minimize)minimize.setAttribute('aria-expanded',value?'false':'true');
      if(value){
        if(quip)quip.textContent=phrases[0];
      }else if(!still&&!reduced){
        void root.offsetWidth;
        root.classList.add('is-opening');
        introTimer=setTimeout(function(){root.classList.remove('is-opening');play()},680);
      }
      if(moveFocus){
        var next=root.closest('[data-gang-dock]')?restore:(value?restore:minimize);
        if(next&&next.focus)next.focus({preventScroll:true});
      }
    }
    // Always minimized on a fresh page, even if expanded on the previous page.
    setMinimized(true,false);
    if(minimize)minimize.addEventListener('click',function(){setMinimized(true,true)});
    if(restore)restore.addEventListener('click',function(){setMinimized(root.closest('[data-gang-dock]') ? !root.classList.contains('is-minimized') : false,true)});
    // Non-interfering close requested by the shared coordinator.
    root.addEventListener('ravin:float:close',function(){
      if(!root.classList.contains('is-minimized'))setMinimized(true,false);
    });
    if(still||reduced)return;
    function schedule(){
      clearTimeout(idleTimer);
      idleTimer=setTimeout(function(){
        if(!root.isConnected)return;
        play();
        schedule();
      },root.classList.contains('rv-rivals--gentle')?14000:8500);
    }
    root.querySelectorAll('[data-rv-choice]').forEach(function(a){
      a.addEventListener('pointerdown',function(){root.classList.add('is-rivalry')},{passive:true});
      a.addEventListener('focus',reset);
    });
    document.addEventListener('visibilitychange',function(){if(document.hidden)reset()});
    schedule();
  }
  function scan(scope){(scope||document).querySelectorAll('[data-rv-rivals]').forEach(setup)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document)});
  else scan(document);
  document.addEventListener('shopify:section:load',function(e){scan(e.target)});
})();
